import axios, { AxiosResponse } from 'axios';
import { GetProviderListPayload } from '../Components/Pages/Providers/useProvidersList'

export async function getProviderList(payload: GetProviderListPayload, mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: {
            totalRecords: 5,
            dataTableData: [
                {
                    providerId: 1,
                    providerName: 'Provider1',
                    providerType: 'Vendor',
                    providerCredential: 'Type A, Type B, Type C',
                    trainingOffered: 'ServSafe'
                },
                {
                    providerId: 2,
                    providerName: 'Provider2',
                    providerType: 'Vendor',
                    providerCredential: 'Type A, Type B, Type C',
                    trainingOffered: 'ServSafe'
                },
                {
                    providerId: 3,
                    providerName: 'Provider3',
                    providerType: 'Vendor',
                    providerCredential: 'Type A, Type B, Type C',
                    trainingOffered: 'ServSafe'
                },
                {
                    providerId: 4,
                    providerName: 'Provider4',
                    providerType: 'Vendor',
                    providerCredential: 'Type A, Type B, Type C',
                    trainingOffered: 'ServSafe'
                },
                {
                    providerId: 5,
                    providerName: 'Provider5',
                    providerType: 'Vendor',
                    providerCredential: 'Type A, Type B, Type C',
                    trainingOffered: 'ServSafe'
                },
            ],
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/Provider/SearchProviders`, payload);
        return result;
    }
}

export async function getMasterForProviderList( mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Master/GetMaster`);
        return result;
    }
}

export async function getFullMasterForProviderList( mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Master/GetFullMaster`);
        return result;
    }
}

export async function getProviderById( providerId:number, mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/provider/${providerId}`);
        return result;
    }
}

export async function getProviderCategories( mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Master/GetProviderCategories`);
        return result;
    }
}

export async function getNoneEmptyProviderCategories( mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Master/GetNoneEmptyProviderCategories`);
        return result;
    }
}

export async function updateProvider( payload: any, isCreate:boolean, mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        if(isCreate){
            let result = await axios.post(`/Provider/CreateProvider`,payload);
            return result;
        }else {
            let result = await axios.post(`/Provider/UpdateProvider`,payload);
            return result;
        }
        
    }
}

export async function deleteProviderById( providerId:number, mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.delete(`/provider/${providerId}`);
        return result;
    }
}